import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, Twitter, Phone, Mail, MapPin } from "lucide-react";
import { FaGooglePlay, FaApple } from "react-icons/fa";
import Logo from "../../../assets/images/logo.png";
import "./Footer.css";

const QUICK_LINKS = [
  { to: "/interiordesign", label: "Interior Design" },
  { to: "/property-services", label: "Property Services" },
  { to: "/property-list?purpose=Buy", label: "Buy Properties" },
  { to: "/property-list?purpose=Rent", label: "Rent Properties" },
  { to: "/partner/signup", label: "Sell / List Property" },
  { to: "/about-us", label: "About Us" },
  { to: "/contactus", label: "Contact Us" },
];

const RESOURCE_LINKS = [
  { to: "/view/all/blogs", label: "Knowledge Hub & Blog" },
  { to: "/about-us", label: "Why All Home Desire" },
  { to: "/partner/signup", label: "Partner Onboarding" },
  { to: "/help-center", label: "Help & Support" },
  { to: "/policy", label: "Trust & Safety" },
];

const LEGAL_LINKS = [
  { to: "/policy", label: "Privacy Policy" },
  { to: "/policy", label: "Terms & Conditions" },
  { to: "/policy", label: "Refund Policy" },
  { to: "/policy", label: "Security Guidelines" },
];

const SOCIALS = [
  { href: "https://www.facebook.com/allhomedesire/", icon: Facebook, label: "Facebook" },
  { href: "https://www.instagram.com/allhomedesire/", icon: Instagram, label: "Instagram" },
  { href: "https://x.com/ushmainfotech", icon: Twitter, label: "Twitter" },
  { href: "https://www.linkedin.com/company/ushma-infotech/posts/?feedView=all", icon: Linkedin, label: "LinkedIn" },
];

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__top">
          {/* Brand Column */}
          <div className="footer__col footer__col--brand">
            <Link to="/" className="footer__logo-link">
              <img src={Logo} alt="All Home Desire" className="footer__logo" />
            </Link>
            <p className="footer__tagline">
              India's premier modern real estate platform. We make buying, selling, and renting properties transparent, verified, and effortless.
            </p>
            <div className="footer__store-btns">
              <a
                href="https://play.google.com/store/apps/details?id=com.AllHomeDesire.AllHomeDesire"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__store-btn"
              >
                <FaGooglePlay className="footer__store-icon" />
                <div className="footer__store-text">
                  <span>Get it on</span>
                  <strong>Google Play</strong>
                </div>
              </a>
              <a
                href="https://apps.apple.com"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__store-btn"
              >
                <FaApple className="footer__store-icon" />
                <div className="footer__store-text">
                  <span>Download on</span>
                  <strong>App Store</strong>
                </div>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer__col">
            <h4 className="footer__col-heading">Quick Links</h4>
            <ul className="footer__link-list">
              {QUICK_LINKS.map(({ to, label }) => (
                <li key={label}>
                  <Link to={to} className="footer__link">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div className="footer__col">
            <h4 className="footer__col-heading">Resources</h4>
            <ul className="footer__link-list">
              {RESOURCE_LINKS.map(({ to, label }) => (
                <li key={label}>
                  <Link to={to} className="footer__link">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div className="footer__col">
            <h4 className="footer__col-heading">Legal</h4>
            <ul className="footer__link-list">
              {LEGAL_LINKS.map(({ to, label }) => (
                <li key={label}>
                  <Link to={to} className="footer__link">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="footer__col footer__col--contact">
            <h4 className="footer__col-heading">Get in Touch</h4>
            <div className="footer__contact-info">
              <div className="footer__contact-item">
                <MapPin size={16} className="footer__contact-icon" />
                <span>7th Avenue, Gaur City 1, Greater Noida West, UP 201308</span>
              </div>
              <div className="footer__contact-item">
                <Phone size={15} className="footer__contact-icon" />
                <a href="tel:+919818961783">+91 9818961783</a>
              </div>
              <div className="footer__contact-item">
                <Mail size={15} className="footer__contact-icon" />
                <a href="mailto:support@allhomedesire.com">support@allhomedesire.com</a>
              </div>
            </div>

            <div className="footer__socials">
              {SOCIALS.map(({ href, icon: Icon, label }) => (
                <a
                  key={label}
                  href={href}
                  className="footer__social-btn"
                  aria-label={label}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer__bottom">
          <p className="footer__copy">
            © {currentYear} <strong>All Home Desire</strong>. All rights reserved.
          </p>
          <div className="footer__bottom-links">
            <Link to="/policy" className="footer__bottom-link">
              Privacy
            </Link>
            <span className="footer__bottom-dot" />
            <Link to="/policy" className="footer__bottom-link">
              Terms
            </Link>
            <span className="footer__bottom-dot" />
            <Link to="/contactus" className="footer__bottom-link">
              Support
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;